
import React, { useMemo, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import CONFIG from '../../config';

function OnlinePayment() {
  const location = useLocation();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const paymentData = location.state || {};

  const {
	order_id = '',
	user_id = '',
	user_name = '',
	user_mobile = '',
	labour_name = '',
	labour_mobile_number = '',
	service_category = '',
	service = '',
	city = '',
	area = '',
	date = '',
	time = '',
	price = CONFIG.DEFAULT_SERVICE_PRICE || 499,
	status = '',
  } = paymentData;

  const finalAmount = useMemo(() => {
	const value = Number(price);
	return Number.isFinite(value) && value > 0
	  ? value
	  : CONFIG.DEFAULT_SERVICE_PRICE || 499;
  }, [price]);

  const styles = {
	page: {
	  minHeight: '100vh',
	  background: 'linear-gradient(135deg, #eef4ff 0%, #f8fbff 45%, #f3f7ff 100%)',
	  padding: '40px 16px',
	  fontFamily: 'Segoe UI, Tahoma, Geneva, Verdana, sans-serif',
	},
	container: {
	  maxWidth: '980px',
	  margin: '0 auto',
	},
	card: {
	  background: '#ffffff',
	  borderRadius: '24px',
	  overflow: 'hidden',
	  boxShadow: '0 20px 60px rgba(15, 23, 42, 0.12)',
	  border: '1px solid #e5e7eb',
	},
	topBanner: {
	  background: 'linear-gradient(135deg, #0f172a 0%, #1d4ed8 100%)',
	  color: '#ffffff',
	  padding: '28px 32px',
	},
	badge: {
	  display: 'inline-block',
	  padding: '6px 12px',
	  borderRadius: '999px',
	  background: 'rgba(255,255,255,0.14)',
	  fontSize: '12px',
	  fontWeight: 700,
	  letterSpacing: '0.4px',
	  marginBottom: '12px',
	},
	heading: {
	  margin: 0,
	  fontSize: '2rem',
	  fontWeight: 800,
	  color: '#ffffff',
	},
	subText: {
	  marginTop: '8px',
	  marginBottom: 0,
	  color: 'rgba(255,255,255,0.88)',
	  fontSize: '15px',
	},
	body: {
	  padding: '28px',
	},
	grid: {
	  display: 'grid',
	  gridTemplateColumns: '1.4fr 0.9fr',
	  gap: '24px',
	},
	sectionCard: {
	  background: '#ffffff',
	  border: '1px solid #eaeef5',
	  borderRadius: '18px',
	  padding: '22px',
	  boxShadow: '0 8px 24px rgba(15, 23, 42, 0.05)',
	},
	sectionTitle: {
	  margin: '0 0 16px 0',
	  fontSize: '1.1rem',
	  fontWeight: 800,
	  color: '#111827',
	},
	detailGrid: {
	  display: 'grid',
	  gridTemplateColumns: '1fr 1fr',
	  gap: '14px',
	},
	detailItem: {
	  background: '#f8fbff',
	  border: '1px solid #e7eef9',
	  borderRadius: '14px',
	  padding: '14px 16px',
	},
	detailLabel: {
	  fontSize: '12px',
	  fontWeight: 700,
	  color: '#64748b',
	  textTransform: 'uppercase',
	  letterSpacing: '0.5px',
	  marginBottom: '6px',
	},
	detailValue: {
	  fontSize: '15px',
	  fontWeight: 600,
	  color: '#111827',
	  wordBreak: 'break-word',
	},
	amountCard: {
	  background: 'linear-gradient(135deg, #eff6ff 0%, #dbeafe 100%)',
	  border: '1px solid #bfdbfe',
	  borderRadius: '18px',
	  padding: '24px',
	  marginBottom: '18px',
	},
	amountLabel: {
	  fontSize: '13px',
	  fontWeight: 700,
	  color: '#1d4ed8',
	  textTransform: 'uppercase',
	  letterSpacing: '0.5px',
	  marginBottom: '8px',
	},
	amountValue: {
	  fontSize: '2.2rem',
	  fontWeight: 800,
	  color: '#0f172a',
	  marginBottom: '8px',
	},
	amountSub: {
	  margin: 0,
	  color: '#475569',
	  fontSize: '14px',
	  lineHeight: 1.5,
	},
	serviceTag: {
	  display: 'inline-block',
	  marginTop: '12px',
	  padding: '8px 12px',
	  borderRadius: '999px',
	  background: '#ffffff',
	  color: '#1d4ed8',
	  border: '1px solid #bfdbfe',
	  fontSize: '13px',
	  fontWeight: 700,
	},
	actionWrap: {
	  display: 'flex',
	  gap: '12px',
	  flexWrap: 'wrap',
	  marginTop: '20px',
	},
	payBtn: {
	  border: 'none',
	  background: loading
		? '#94a3b8'
		: 'linear-gradient(135deg, #16a34a 0%, #22c55e 100%)',
	  color: '#ffffff',
	  borderRadius: '999px',
	  padding: '14px 24px',
	  fontSize: '15px',
	  fontWeight: 800,
	  cursor: loading ? 'not-allowed' : 'pointer',
	  minWidth: '170px',
	  boxShadow: loading ? 'none' : '0 12px 24px rgba(34, 197, 94, 0.22)',
	},
	backBtn: {
	  border: '1px solid #cbd5e1',
	  background: '#ffffff',
	  color: '#1f2937',
	  borderRadius: '999px',
	  padding: '14px 24px',
	  fontSize: '15px',
	  fontWeight: 700,
	  cursor: 'pointer',
	  minWidth: '130px',
	},
	noteBox: {
	  marginTop: '18px',
	  background: '#fff7ed',
	  border: '1px solid #fed7aa',
	  borderRadius: '14px',
	  padding: '14px 16px',
	  color: '#9a3412',
	  fontSize: '14px',
	  lineHeight: 1.5,
	},
	emptyWrap: {
	  minHeight: '100vh',
	  display: 'flex',
	  alignItems: 'center',
	  justifyContent: 'center',
	  background: 'linear-gradient(135deg, #eef4ff 0%, #f8fbff 100%)',
	  padding: '24px',
	  fontFamily: 'Segoe UI, Tahoma, Geneva, Verdana, sans-serif',
	},
	emptyCard: {
	  width: '100%',
	  maxWidth: '520px',
	  background: '#ffffff',
	  borderRadius: '20px',
	  padding: '28px',
	  boxShadow: '0 18px 50px rgba(15, 23, 42, 0.1)',
	  border: '1px solid #e5e7eb',
	  textAlign: 'center',
	},
	emptyTitle: {
	  marginTop: 0,
	  marginBottom: '10px',
	  color: '#111827',
	},
	emptyText: {
	  color: '#6b7280',
	  marginBottom: '18px',
	},
	statusBadge: {
	  display: 'inline-block',
	  padding: '8px 14px',
	  borderRadius: '999px',
	  background: '#f3f4f6',
	  color: '#374151',
	  fontSize: '13px',
	  fontWeight: 700,
	  marginTop: '8px',
	},
  };

  const loadRazorpayScript = () => {
	return new Promise((resolve) => {
	  if (window.Razorpay) {
		resolve(true);
		return;
	  }

	  const script = document.createElement('script');
	  script.src = 'https://checkout.razorpay.com/v1/checkout.js';
	  script.onload = () => resolve(true);
	  script.onerror = () => resolve(false);
	  document.body.appendChild(script);
	});
  };

  const openRazorpayCheckout = async (data) => {
	const loaded = await loadRazorpayScript();
	if (!loaded) {
	  alert('Razorpay failed to load');
	  return;
	}

	const options = {
	  key: data.key,
	  amount: data.amount,
	  currency: 'INR',
	  name: 'DigiLabour',
	  description: 'Service Payment',
	  order_id: data.razorpay_order_id,
	  handler: function () {
		alert('Payment Successful');
		navigate('/UserDashboard');
	  },
	  prefill: {
		name: user_name,
		contact: user_mobile,
	  },
	  theme: { color: '#1976d2' },
	};

	new window.Razorpay(options).open();
  };

const [paymentMessage, setPaymentMessage] = useState('');

const handleProceedPayment = async () => {
  try {
	setLoading(true);
	setPaymentMessage('');

	const paymentData =
	  location.state ||
	  JSON.parse(sessionStorage.getItem('onlinePaymentData') || '{}');

	if (!paymentData?.order_id) {
	  alert('Payment details not found');
	  return;
	}

	const payload = {
	  ...paymentData,
	  paid_amount: paymentData.price || paymentData.service_charge || finalAmount,
	  final_amount: finalAmount,
	  payment_status: 'initiated',
	  transaction_date: new Date().toISOString(),
	};

	const response = await fetch(
	  `${CONFIG.API_BASE_URL}/api/payment/create-order/`,
	  {
		method: 'POST',
		headers: {
		  'Content-Type': 'application/json',
		},
		body: JSON.stringify(payload),
	  }
	);

	const result = await response.json();

	const isSuccess = response.ok && (result.success || result.status === 10);

	const updatedPaymentData = {
	  ...paymentData,
	  backend_response: result,
	  transaction_id: result.transaction_id || result.payment_id || '',
	  payment_done_at: new Date().toISOString(),
	  status: isSuccess ? 10 : 11,
	  payment_result: isSuccess ? 'success' : 'failed',
	};

	sessionStorage.setItem(
	  'onlinePaymentData',
	  JSON.stringify(updatedPaymentData)
	);

	setPaymentMessage(
	  isSuccess
		? 'Payment successful. Redirecting...'
		: 'Payment failed. Redirecting...'
	);

	setTimeout(() => {
	  navigate(paymentData.redirect_to || '/UserDashboard', {
		state: updatedPaymentData,
		replace: true,
	  });
	}, 1500);
  } catch (error) {
	const paymentData =
	  location.state ||
	  JSON.parse(sessionStorage.getItem('onlinePaymentData') || '{}');

	const failedPaymentData = {
	  ...paymentData,
	  status: 11,
	  payment_result: 'failed',
	  error_message: error.message || 'Something went wrong',
	  payment_done_at: new Date().toISOString(),
	};

	sessionStorage.setItem(
	  'onlinePaymentData',
	  JSON.stringify(failedPaymentData)
	);

	setPaymentMessage('Payment failed. Redirecting...');

	setTimeout(() => {
	  navigate(paymentData.redirect_to || '/UserDashboard', {
		state: failedPaymentData,
		replace: true,
	  });
	}, 1500);
  } finally {
	setLoading(false);
  }
};

  if (!order_id) {
	return (
	  <div style={styles.emptyWrap}>
		<div style={styles.emptyCard}>
		  <h2 style={styles.emptyTitle}>Online Payment</h2>
		  <p style={styles.emptyText}>Payment details are missing.</p>
		  <button style={styles.backBtn} onClick={() => navigate(-1)}>
			Back
		  </button>
		</div>
	  </div>
	);
  }

  return (
	<div style={styles.page}>
	  <div style={styles.container}>
		<div style={styles.card}>
		  <div style={styles.topBanner}>
			<div style={styles.badge}>Secure Payment</div>
			<h2 style={styles.heading}>Complete Your Payment</h2>
			<p style={styles.subText}>
			  Review the booking details below and continue to Razorpay securely.
			</p>
		  </div>

		  <div style={styles.body}>
			<div style={styles.grid}>
			  <div style={styles.sectionCard}>
				<h3 style={styles.sectionTitle}>Booking Details</h3>

				<div style={styles.detailGrid}>
				  <div style={styles.detailItem}>
					<div style={styles.detailLabel}>Order ID</div>
					<div style={styles.detailValue}>{order_id || '-'}</div>
				  </div>

				  <div style={styles.detailItem}>
					<div style={styles.detailLabel}>User ID</div>
					<div style={styles.detailValue}>{user_id || '-'}</div>
				  </div>

				  <div style={styles.detailItem}>
					<div style={styles.detailLabel}>User Name</div>
					<div style={styles.detailValue}>{user_name || '-'}</div>
				  </div>

				  <div style={styles.detailItem}>
					<div style={styles.detailLabel}>Mobile</div>
					<div style={styles.detailValue}>{user_mobile || '-'}</div>
				  </div>

				  <div style={styles.detailItem}>
					<div style={styles.detailLabel}>Service Category</div>
					<div style={styles.detailValue}>{service_category || '-'}</div>
				  </div>

				  <div style={styles.detailItem}>
					<div style={styles.detailLabel}>Service</div>
					<div style={styles.detailValue}>{service || '-'}</div>
				  </div>

				  <div style={styles.detailItem}>
					<div style={styles.detailLabel}>City</div>
					<div style={styles.detailValue}>{city || '-'}</div>
				  </div>

				  <div style={styles.detailItem}>
					<div style={styles.detailLabel}>Area</div>
					<div style={styles.detailValue}>{area || '-'}</div>
				  </div>

				  <div style={styles.detailItem}>
					<div style={styles.detailLabel}>Date</div>
					<div style={styles.detailValue}>{date || '-'}</div>
				  </div>

				  <div style={styles.detailItem}>
					<div style={styles.detailLabel}>Time</div>
					<div style={styles.detailValue}>{time || '-'}</div>
				  </div>

				  <div style={styles.detailItem}>
					<div style={styles.detailLabel}>Labour Name</div>
					<div style={styles.detailValue}>{labour_name || 'Not Assigned'}</div>
				  </div>

				  <div style={styles.detailItem}>
					<div style={styles.detailLabel}>Labour Mobile</div>
					<div style={styles.detailValue}>{labour_mobile_number || 'Not Available'}</div>
				  </div>
				</div>
			  </div>

			  <div>
				<div style={styles.amountCard}>
				  <div style={styles.amountLabel}>Payable Amount</div>
				  <div style={styles.amountValue}>₹{finalAmount}</div>
				  <p style={styles.amountSub}>
					This amount will be charged for the booked service.
				  </p>
				  <div style={styles.serviceTag}>{service || 'Service Booking'}</div>
				</div>

				<div style={styles.sectionCard}>
				  <h3 style={styles.sectionTitle}>Payment Action</h3>
				  <div style={styles.statusBadge}>
					Current Status: {status || 'Pending'}
				  </div>

				  <div style={styles.actionWrap}>
					<button
					  style={styles.payBtn}
					  onClick={handleProceedPayment}
					  disabled={loading}
					>
					  {loading ? 'Processing...' : `Pay ₹${finalAmount}`}
					</button>

					<button
					  style={styles.backBtn}
					  onClick={() => navigate(-1)}
					>
					  Back
					</button>
				  </div>
				  {paymentMessage ? (
					  <p
						style={{
						  marginTop: 12,
						  marginBottom: 0,
						  color: paymentMessage.toLowerCase().includes('successful') ? 'green' : 'red',
						  fontWeight: 600,
						  fontSize: '14px',
						}}
					  >
						{paymentMessage}
					  </p>
					) : null}


				  <div style={styles.noteBox}>
					You will be redirected to Razorpay secure checkout after clicking the payment button.
				  </div>
				</div>
			  </div>
			</div>
		  </div>
		</div>
	  </div>

	  <style>
		{`
		  @media (max-width: 900px) {
			.payment-grid {
			  grid-template-columns: 1fr;
			}
		  }
		`}
	  </style>
	</div>
  );
}


export default OnlinePayment;